/* System defined core library */
import { Component } from '@angular/core';

/* Images */
const prometricImg = require('../../../../../../Assets/images/prometric_icon.png');
const dttGif = require('../../../../../../Assets/App_themes/DTT/images/theorytestie.gif');
const fitchRightImg = require('../../../../../../Assets/App_themes/FTLRN/images/fitch_right.png');

@Component({
  selector: 'navbar-brand-right',
  templateUrl: './navbar-brand-right.component.html',
  styleUrls: ['./navbar-brand-right.component.scss']
})
export class NavbarBrandRight {

  public prometric = prometricImg;
  public dtt = dttGif;
  public fitchRight = fitchRightImg;

  /* Constructor declaration with required injected services */
  constructor(

  ) {

  }

  /* Initialize the component & call required methods when component loaded first time. */
  ngOnInit() {

  }
}
